type useGetEnvType = (type: string) => string | undefined;

export const useGetEnv: useGetEnvType = type => {
	const dataType = `REACT_APP_${type.toUpperCase()}`;
	return process.env[dataType];
};
